import React, { Component } from 'react';
import PropTypes from 'prop-types';

// logic dependencies
import { BORDER_POSITION } from 'logic/data/Izenda.PropertiesBuilderConstants.js'

class GridBorderPreview extends Component {
    render() {
        const {
            getStylesBorder
        } = this.props;

        return (
            <div className='border-preview'>
                <div className='border-box box1' style={getStylesBorder(BORDER_POSITION.ALL)} />
                <div className='border-box box2' style={getStylesBorder(BORDER_POSITION.MID_HOR)} />
                <div className='border-box box3' style={getStylesBorder(BORDER_POSITION.MID_VER)} />
                <div className='border-paragraph'>
                    <i className='icon-pra' />
                    <i className='icon-pra' />
                    <i className='icon-pra' />
                    <i className='icon-pra' />
                </div>
            </div>
        );
    }
}

GridBorderPreview.propTypes = {
    getStylesBorder: PropTypes.func.isRequired
};

export default GridBorderPreview;



// WEBPACK FOOTER //
// ./ui/share/components/controls/Izenda.GridBorderPreview.jsx